import $ from 'jquery';
import SidebarParamClinique from './sidebar-param-clinique'
import SidebarClinique from './sidebar-clinique'
import SidebarMDT from './sidebar-mdt'
import canAccessRma from '@/router/rma-access'
import { calculerBadges, libelleBadge, INTERVALLE_BADGES, SON_DU_BADGE, alertesDuRole } from '@/utils/badges-sidebar'
import { jouer, nouveautes, sonAJouer } from '@/utils/sons-alertes'
import ReglagesSons from '@/components/reglages-sons'

export default {
    name: 'sidebar',
    components: {
        SidebarParamClinique, SidebarClinique,
        SidebarMDT, ReglagesSons
    },
    props: [],
    data() {
        return {
            user_role: '',           //  Role d'un utilisateur
            is_param: false,
            // Pastilles « du nouveau » (04/10/2026) : transferts à accueillir, soins en retard / maintenant.
            badges: { parcours: 0, soins: 0 },
            minuteur_badges: null,
            // Première lecture = référence : aucun son au chargement, seulement quand une pastille augmente ensuite.
            badges_lus: false,
            badges_en_cours: null
        }
    },
    computed: {
        alertesSons() {
            return alertesDuRole(this.activeRole && this.activeRole.nom)
        },
        canAccessRma() {
            return canAccessRma(this.activeRole)
        },
        /**
         * Get User info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },
    },
    mounted() {
        if (this.userCredentials.roles.length > 0) {
            this.user_role = this.userCredentials.roles[0].nom;
        }

        this.getCurrentPath()
        this.chargerBadges()
        this.minuteur_badges = setInterval(this.chargerBadges, INTERVALLE_BADGES)
        document.addEventListener('visibilitychange', this.chargerBadges)
    },

    beforeDestroy() {
        clearInterval(this.minuteur_badges)
        document.removeEventListener('visibilitychange', this.chargerBadges)
    },

    watch: {
        'activeRole.nom'() { this.badges = { parcours: 0, soins: 0 }; this.badges_lus = false; this.chargerBadges() },
    },

    methods: {
        libelleBadge,
        async chargerBadges() {
            if (typeof document !== 'undefined' && document.hidden) return
            const role = this.activeRole && this.activeRole.nom
            if (!role || this.badges_en_cours === role) return
            this.badges_en_cours = role
            const avant = this.badges_lus ? this.badges : null
            const apres = await calculerBadges(role, this.badges)
            if (this.badges_en_cours === role) this.badges_en_cours = null
            if (role !== (this.activeRole && this.activeRole.nom)) return
            this.badges = apres
            this.badges_lus = true
            // Un seul son, le plus urgent, et seulement si une pastille a augmenté.
            const type = sonAJouer(nouveautes(avant, apres).map(cle => SON_DU_BADGE[cle]))
            if (type) jouer(type)
        },
        onSidebarItemClick(e) {
            // Close sidebar when any menu <li> is clicked (mobile behavior),
            // but don't close when the click is only meant to expand/collapse a submenu.
            const $target = $(e.target);
            if ($target.closest('a[data-toggle="collapse"]').length) return;

            // Only react to clicks within an <li> inside the menu
            if (!$target.closest('li').length) return;

            this.getCurrentPath();
            this.closeSidebar();
        },
        
        toggleClassChevron: function (htmlclass) {
            let className = $('.' + htmlclass + " .chevron i").attr('class')

            if (className === "fa fa-chevron-down ico-small") {
                $('.' + htmlclass + " .chevron i").removeClass('fa-chevron-down ico-small')
                $('.' + htmlclass + " .chevron i").addClass("fa-chevron-up ico-small")
            } else {
                $('.' + htmlclass + " .chevron i").removeClass('fa-chevron-up ico-small')
                $('.' + htmlclass + " .chevron i").addClass("fa-chevron-down ico-small")
            }
        },

        getCurrentPath() {
            let path = this.$route.path
            
            this.is_param = path.includes("parametres")
        },

        closeSidebar() {
            const sidebar = $('#sdbr');
            if (sidebar.hasClass('shw-sdbar')) {
                sidebar.removeClass('shw-sdbar');
                // Trigger toggleSidebar in navbar to update the icon state
                this.$root.$emit('closeSidebar');
            }
        }
    }
}


